module.exports = __webpack_public_path__ + "img/Flaticon.c172951.svg";